import React, { useMemo } from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { NETWORK_STATUS_CONFIG } from "../../../config/networkStatus.config.ts"
import { NetworkStatusHelper } from "../../../helpers/networkStatus.helper.ts"

export const RulesTableHeaderComponent: React.FunctionComponent<
    IRulesTableHeaderComponentProps
> = props => {
    const ruleDisplayData = useMemo(() => {
        return NetworkStatusHelper.getRuleDisplayData(null)
    }, [])

    return (
        <div className="table-row w-full">
            <div className="flex items-center gap-[16px] bg-brand-white px-[16px]">
                {props.showIdColumn && (
                    <PrimaryText
                        typography="h6"
                        className="opacity-75 w-[80px] flex-shrink-0 py-[8px]"
                    >
                        {ruleDisplayData.id.label}
                    </PrimaryText>
                )}

                {NETWORK_STATUS_CONFIG.ruleDisplayTableRowKeys.map(
                    (dataKey, index) => {
                        const config = ruleDisplayData[dataKey]

                        return (
                            <PrimaryText
                                key={index}
                                typography="h6"
                                className={`
                                    opacity-75 flex-shrink-0 py-[8px]
                                    ${config.tableWidthClassName || "w-[150px]"}
                                `}
                            >
                                {config.label}
                            </PrimaryText>
                        )
                    },
                )}
            </div>
        </div>
    )
}

interface IRulesTableHeaderComponentProps {
    // Show ID column (default true). Set false for review-new-rules flow.
    showIdColumn: boolean
}
